import request from '@/utils/request'
import store from '@/store'
export const NavService = {
  fetchRoutes,
}

function fetchRoutes(){
  let role = store.state.user.current.role
  return request({
    url:'/menu',
    method:'post',
    data:{
      role:role
    }
  })
}
